<template>
    <div class="login-container">
        <h2>登录</h2>
        <form @submit.prevent="handleLogin">
            <div class="form-group">
                <input type="text" id="username" v-model="username" required placeholder="请输入用户名"/>
            </div>
            <div class="form-group">
                <input type="password" id="password" v-model="password" required placeholder="请输入登录密码"/>
            </div>
            <div class="spacer"></div>
            <button type="submit">登录</button>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import { showSuccess,showError,showInfo } from '../utils';
const axiosInstance = axios.create({
    baseURL: 'https://relia-server.com:3000',
    timeout: 10000,
     withCredentials: true
});

export default {
    name: 'Login',
    data() {
        return {
            username: '',
            password: ''
        };
    },
    methods: {
        async handleLogin() {
            // 处理登录逻辑
            //console.log('用户名:', this.username);
            //console.log('密码:', this.password);
            console.log(`${new Date().toISOString()} 登录中...`);

            try {
                const response = await axiosInstance.post('/api/login', {
                    username: this.username,
                    password: this.password
                });

                if (response.data.success) {
                    // 保存当前登录用户名和密码
                    localStorage.setItem('currentUser', this.username);
                    localStorage.setItem('currentPassword', this.password);

                    if(this.username === 'zhiliang' && this.password == 'zhiliang'){
                      // 质量部上传文件
                      this.$router.push('upload-lab-sheet');
                      showSuccess('登录成功');
                    }else{
                      this.$router.push('gate');
                      showSuccess('登录成功');
                    }
                } else {
                    showError('用户名或密码错误');
                }
            } catch (error) {
                showError('登录请求失败，请稍后再试');
            }
        }
    }
};
</script>

<style scoped>
/* 登录容器样式 */
.login-container {
    max-height: 300px;
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.form-group {
    /*设置边距*/
    margin-bottom:20px;
}

.form-group label {
    display: inline-block;
    width: 70px; /* 设置用户名文字的宽度 */
}
/* 输入框样式 */
.form-group input {
    width: calc(100% - 110px);
    padding: 8px;
    box-sizing: border-box;
    margin-left: 10px;
}

.spacer{
    height: 20px;
}

/* 按钮样式 */
button {
    width: 80%;
    padding: 10px;
    background-color: #2ab1f4;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
/* 按钮悬停样式 */
button:hover {
    background-color: #1a91d5; /* 深蓝色 */
    transform: scale(1.05); /* 悬停时稍微放大 */
}
</style>
